import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=5b86b60b&scoped=true&"
import script from "./GlobalHeader.vue?vue&type=script&lang=ts&"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=5b86b60b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86b60b",
  null
  
)

export default component.exports